<template>
  <div>
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <div class="modal is-active" v-show="showCreateOrEditModal">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Product/Service</p>
          <button
            class="delete"
            aria-label="close"
            @click="closeModal"
          ></button>
        </header>
        <section class="modal-card-body">
          <h4 class="title is-4">{{ createOrUpdate }}</h4>
          <div class="columns">
            <div class="column is-12">
              <div class="field">
                <label class="label is-small">Name</label>
                <div class="control">
                  <input
                    type="text"
                    class="input is-small"
                    v-model="productOrService.name"
                    placeholder="Enter the name here"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-8">
              <div class="field">
                <label class="label is-small">Description</label>
                <textarea
                  style="height: 50px"
                  type="text"
                  class="input is-small"
                  v-model="productOrService.desc"
                  placeholder="Enter description (if any)"
                />
              </div>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label is-small">Product type</label>
                <div class="select is-small">
                  <select v-model="productOrService.productType">
                    <option value="0">INVENTORY</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-3">
              <div class="field">
                <label class="label is-small">SKU</label>
                <div class="control">
                  <input
                    type="text"
                    class="input is-small"
                    v-model="productOrService.sku"
                  />
                </div>
              </div>
            </div>
            <div class="column is-2">
              <div class="field">
                <label class="label is-small">QTY on hand</label>
                <div class="control">
                  <input
                    type="number"
                    class="input is-small"
                    v-model="productOrService.qtyOnHand"
                  />
                </div>
              </div>
            </div>
            <div class="column is-3">
              <div class="field">
                <label class="label is-small">Cost</label>
                <div class="control">
                  <input
                    type="number"
                    class="input is-small"
                    v-model="productOrService.cost"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end">
          <button :class="buttonSave" @click="savePos">
            Save
            <span v-if="productOrServiceState.isSaveAndUse">&nbsp;and use</span>
          </button>
          <button class="button is-small" @click="closeModal">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import axios from "axios";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";
import AuthService from "../../_services/auth";

const appToast = new AppToast();
const appButton = new AppButton();
const authService = new AuthService();

export default {
  data: () => ({
    hasAdminSalesAndMainAdminPriv: authService.hasAdminSalesAndMainAdminPriv(),
    createOrUpdate: "Create",
    isFullPage: true,
    isLoading: false,
    buttonSave: appButton.isLoadingSuccess(false),
    productOrService: {
      productOrServiceId: 0,
      name: "",
      sku: "",
      productType: 0,
      desc: "",
      salesPrice: 0,
      cost: 0,
      qtyOnHand: 0,
    },
    productOrServiceCreatedId: 0,
  }),
  computed: {
    ...mapState("productorservice", {
      showCreateOrEditModal: (state) => state.showCreateOrEditModal,
      productOrServiceState: (state) => state.productOrServiceState,
    }),
  },
  created() {
    const productOrServiceId = this.productOrServiceState.productOrServiceId;
    if (productOrServiceId) {
      this.getPos(productOrServiceId);
    }
  },
  methods: {
    ...mapActions("productorservice", [
      "openCreateEditModal",
      "getPaginatedData",
    ]),
    default() {
      this.productOrService = {
        productOrServiceId: 0,
        name: "",
        sku: "",
        productType: 0,
        desc: "",
        salesPrice: 0,
        cost: 0,
        qtyOnHand: 0,
      };
    },
    getPos(id) {
      if (id) {
        this.isLoading = true;
        axios
          .get(`api/productsorservices/${id}`)
          .then((response) => {
            this.productOrService = response.data;
          })
          .catch((error) => console.log(error))
          .then(() => (this.isLoading = false));
      }
    },
    savePos() {
      if (!this.productOrService.name.trim()) {
        appToast.danger("Name is required");
        return false;
      }
      this.buttonSave = appButton.isLoadingSuccess(true);
      const productOrServiceId = this.productOrService.productOrServiceId;
      if (productOrServiceId) {
        // Edit
        axios
          .put(
            `api/productsorservices/${productOrServiceId}`,
            this.productOrService
          )
          .then((response) => {
            appToast.success(response.data);
            this.closeModal();
          })
          .catch((error) => {
            appToast.danger(error.response.data);
            console.log(error.response);
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false);
          });
      } else {
        axios
          .post(`api/productsorservices`, this.productOrService)
          .then((response) => {
            appToast.success(response.data.message);
            this.productOrServiceCreatedId = response.data.id;
            this.closeModal();
          })
          .catch((error) => {
            console.log(error.response);
            appToast.danger(error.response.data);
          })
          .then(() => {
            this.buttonSave = appButton.isLoadingSuccess(false);
          });
      }
    },
    closeModal() {
      this.defaultForList();
      this.default();
    },
    defaultForList() {
      this.openCreateEditModal({
        showCreateOrEditModal: false,
        productOrServiceState: {
          productOrServiceId: this.productOrServiceState.isSaveAndUse
            ? this.productOrServiceCreatedId
            : 0,
          isSaveAndUse: this.productOrServiceState.isSaveAndUse,
          productOrServiceName: this.productOrService.name.toLocaleUpperCase(),
          desc: this.productOrService.desc,
          sku: this.productOrService.sku,
          qty: this.productOrService.qtyOnHand,
          cost: this.productOrService.cost,
        },
      });
      this.getPaginatedData({
        page: 1,
        pageSize: 10,
        query: "",
      });
    },
  },
  watch: {
    productOrServiceState() {
      if (this.showCreateOrEditModal) {
        if (typeof this.productOrServiceState.productOrServiceId === "number") {
          this.createOrUpdate = "Edit";
          this.getPos(this.productOrServiceState.productOrServiceId);
        } else {
          this.createOrUpdate = "Create";
        }
      }
    },
  },
};
</script>
